import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from 'reactstrap';

import { loginAdmin } from '../../utils';

// Replaces the native prompt() pair used for admin login. Rendered as a
// pre-app gate by index.js when there is no stored session (the Redux/modal
// tree does not exist yet at that point, so this is a self-contained screen).
// Calls `onAuthenticated(user)` once `/login` succeeds.
class LoginScreen extends Component {
  state = {
    phone: '',
    password: '',
    loading: false,
    error: '',
  };

  onChange = (field) => (e) => this.setState({ [field]: e.target.value });

  submit = (e) => {
    e.preventDefault();
    const { phone, password, loading } = this.state;
    if (loading || !phone || !password) return;

    this.setState({ loading: true, error: '' });
    loginAdmin({ phone, password })
      .then((user) => {
        // Leave `loading` true — the parent swaps this screen for the app.
        this.props.onAuthenticated(user);
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error:
            (err && (err.message || err.error)) ||
            'Login failed. Please check your credentials and try again.',
        });
      });
  };

  render() {
    const { phone, password, loading, error } = this.state;

    return (
      <div
        className="full-page"
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          background: '#1a1a2e',
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} sm={8} md={6} lg={4}>
              <div className="text-center mb-3">
                <h3 className="text-white">BUYPOWER</h3>
                <p className="text-white">Admin sign in</p>
              </div>
              <Card>
                <CardBody>
                  <Form onSubmit={this.submit}>
                    {error ? <Alert color="danger">{error}</Alert> : null}
                    <FormGroup>
                      <Label for="login-phone">Username</Label>
                      <Input
                        id="login-phone"
                        type="text"
                        autoFocus
                        autoComplete="username"
                        value={phone}
                        disabled={loading}
                        onChange={this.onChange('phone')}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="login-password">Password</Label>
                      <Input
                        id="login-password"
                        type="password"
                        autoComplete="current-password"
                        value={password}
                        disabled={loading}
                        onChange={this.onChange('password')}
                      />
                    </FormGroup>
                    <Button
                      color="primary"
                      block
                      type="submit"
                      disabled={loading || !phone || !password}
                    >
                      {loading ? 'Signing in…' : 'Sign in'}
                    </Button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default LoginScreen;
